import React, { useState, useRef } from "react";
import { FaArrowAltCircleDown, FaStar } from "react-icons/fa";
import "./css/ItinearySection.css";
import { RiArrowDropDownLine } from "react-icons/ri";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper";
import { Row } from "react-bootstrap";
import ItineraryPage from "./ItineraryPage";

const ItinearySection = ({ data }) => {
  //   console.log("testtest",data);

  const swiperRef = useRef(null);

  const [activeTab, setActiveTab] = useState(0);

  const toggleTab = (tab) => {
    if (activeTab === tab) {
      setActiveTab(0);
    } else {
      setActiveTab(tab);
    }
  };
  return (
    <>
      <div className=" mt-8 ">
        <div>
          <div className="intineraryMainDiv mt-4 mb-5" id="ltinerary">
            <h2 className="intineraryMainhead text-[18px] font-[600] mb-4">
              Itineraries
            </h2>
            {/* hs */}
            <ul
              id="first-list"
              ng-repeat="tblIti in packDetails.tableItinerary.Itinerarys"
              className="ng-scope"
            >
              {data.packagedetail.package_itinerary.map((item, id) => (
                <li>
                  <div className="boxnvd ">
                    <div className="boxhed ng-binding">
                      {" "}
                      <span className="mobdayhide ng-binding">
                        {" "}
                        Day {id + 1}{" "}
                      </span>{" "}
                      {item.title}
                    </div>
                    <div className="innerbx">
                      <div
                        ng-repeat="dyIti in tblIti.Itinerary"
                        className="ng-scope"
                      >
                        <section className="mtags exlstvg">
                          <div className="" />
                          <ul>
                            <li
                              ng-if="dyIti.UsedType != 'Img'"
                              className="dspn ng-scope"
                            >
                              <div
                                ng-bind-html="dyIti.Description | convertHtml"
                                className="ng-binding"
                                dangerouslySetInnerHTML={{
                                  __html: item.details,
                                }}
                              ></div>
                              Meals:{" "}
                              {item.foodtype
                                ?.split(",")
                                .map((s) => s.trim())
                                .filter(Boolean) // remove empty items
                                .map(
                                  (s) => s.charAt(0).toUpperCase() + s.slice(1),
                                )
                                .join(", ")}
                            </li>
                          </ul>
                        </section>
                        <div className="clr" />
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>

            {/* hs */}
            <div className="newiti">
              {data.packagedetail.package_itinerary.map((item, id) => (
                <div className="itinerarysecDiv" key={id}>
                  <button
                    className="itinerarysecDivbtn1"
                    onClick={() => toggleTab(item.id)}
                  >
                    {/* <div className="itinerarysecDIvMain "> */}
                    <div className="itinerarysecDiv2">
                      <div style={{ display: "flex" }}>
                        <span
                          className="itinerarysecDiv2para1"
                          style={{ marginRight: "10px" }}
                        >
                          Day {id + 1}
                        </span>
                        <span className="itinerarysecDiv2para2">
                          {item.title}
                        </span>
                      </div>
                      <div>
                        {activeTab === item.id ? (
                          <FiMinusCircle />
                        ) : (
                          <FiPlusCircle />
                        )}
                      </div>
                    </div>
                    <div>
                      {/* <RiArrowDropDownLine size={25} color="#f73030" /> */}
                      {/* </div> */}
                    </div>
                  </button>
                  {activeTab === item.id && (
                    <div className="mt-2">
                      <p
                        className="itinerarysecDiv2para3"
                        dangerouslySetInnerHTML={{ __html: item.details }}
                      ></p>
                      {/* <p
                                                className="itinerarysecDiv2para3"
                                            >
                                            Meals: {item.foodtype
                                            ?.split(",")
                                            .map(s => s.trim())
                                            .filter(Boolean) // remove empty items
                                            .map(s => s.charAt(0).toUpperCase() + s.slice(1))
                                            .join(", ")
                                            }

                                                </p> */}
                          {item.foodtype && item.foodtype.trim() !== "" && (
                            <p className="itinerarysecDiv2para3">
                              Meals:{" "}
                              {item.foodtype
                                .split(",")
                                .map((s) => s.trim())
                                .filter(Boolean)
                                .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
                                .join(", ")}
                            </p>
                          )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

                    <div id="inclusion">
            <h2 className="itineraryInclusion">Inclusions</h2>
            <ul className="itineraryInclusionUnder">
              {/* {data.packagedetail.package_inclusions.map((item) => (
                                <div className="itineraryInclusionInnerDiv">
                                    <span className=""> ✔ </span>
                                    <li dangerouslySetInnerHTML={{ __html: item }}></li>
                                </div>
                            ))} */}
              {data.packagedetail.package_inclusions
                .filter((item) => item && item.trim() !== "")
                .map((item, index) => (
                  <div key={index} className="itineraryInclusionInnerDiv">
                    <span>✔</span>{" "}
                    <li dangerouslySetInnerHTML={{ __html: item }}></li>
                  </div>
                ))}
            </ul>
          </div>
          <div id="exclusion">
            <h2 className="itineraryInclusion">Exclusions</h2>

            <ul className="itineraryInclusionUnder">
              {data.packagedetail.package_exclusions
                .filter((item) => item && item.trim() !== "")
                .map((item, index) => (
                  <div key={index} className="itineraryInclusionInnerDivs">
                    <span>⨯</span>
                    <li dangerouslySetInnerHTML={{ __html: item }}></li>
                  </div>
                ))}
            </ul>
          </div>


          {/* <div>   
      <h3 className="itineraryInclusion">Best Time to Visit Bhutan</h3>
      <p className="itineraryInclusionUnder">March to May and September to November are ideal for clear skies and comfortable weather. Spring offers blooming rhododendrons, while autumn provides excellent mountain views.</p>
          </div> */}
{/* 
    <div >
    <h3 className="itineraryInclusion">Travel Notes</h3>
      <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
        <li style={{ marginLeft: '6px' }}>Comfortable walking shoes are recommended for Tiger’s Nest hike.</li>
        <li style={{ marginLeft: '6px' }}>Altitude changes are gradual but staying hydrated is advised.</li>
        <li style={{ marginLeft: '6px' }}>Bhutan maintains a strong cultural code; modest dressing is appreciated at monasteries.</li>
      </ul>
          </div> */}
{/* 
          <div>
            <h3 className="itineraryInclusion">Why Book Bhutan With Plenary Holidays?</h3>
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
            <li style={{ marginLeft: '6px' }}>16+ years of structured travel experience</li>
            <li style={{ marginLeft: '6px' }}>Dedicated Bhutan specialists</li>
            <li style={{ marginLeft: '6px' }}>Flexible customization for FIT & GIT</li>
            <li style={{ marginLeft: '6px' }}>Transparent pricing & professional documentation</li>
            <li style={{ marginLeft: '6px' }}>Trusted network of local partners</li>
            </ul>
          </div> */}


          {/* {data.packagedetail.hotel && data.packagedetail.hotel.length > 0 && (
            <div className="itineraryHotelDetailMainHead" id="Hotels">
              <h2 className="itineraryHotelDetailHead">Hotel Details</h2>
              {data.packagedetail.hotel.map((item) => (
                <div className="itineraryHotelDetailMain">
                  <div className="itineraryHotelDetailMain2">
                    <Row>
                      <Swiper
                        slidesPerView={1}
                        spaceBetween={40}
                        pagination={{ clickable: true }}
                        modules={[Autoplay]}
                        autoplay
                        loop
                        className="mySwiper"
                        style={{ paddingBottom: "40px" }}
                        onSwiper={(swiper) => {
                          swiperRef.current = swiper;
                        }}
                      >
                        {item.hotel_gallery.map((itemx, index) => (
                          <SwiperSlide key={index}>
                            <img
                              src={itemx.image}
                              className="ItineraryHotelDetailMainImage"
                              alt={item.image_alt}
                            />
                          </SwiperSlide>
                        ))} 
                      </Swiper>
                    </Row>
                  </div>
                  <div className="itineraryHotelDetailMain3">
                    <div className="itineraryHotelDetailMain3Inner">
                      <h3 className="itineraryHotelDetailMain3Innerh3 ">
                        {item.name}
                      </h3>
                      <p className="itineraryHotelDetailpara1">
                        Include a trip
                      </p>
                    </div>
                    <div className="itineraryHotelDetailStar">
                      <FaStar size={13.5} color="#f5b800" />
                      <FaStar size={13.5} color="#f5b800" />
                      <FaStar size={13.5} color="#f5b800" />
                    </div>
                    <div>
                      <p className="itineraryHotelDetailpara3">
                        <span style={{ fontWeight: "600" }}>Address: </span>{" "}
                        {item.address}
                      </p>
                    </div>
                    <div style={{ textAlign: "end", width: "100%" }}>
                      <p className="itineraryHotelDetailparaIn">Include a trip</p>
                    </div>
                    <div></div>
                  </div>
                </div>
              ))}
            </div>
          )} */}

          {/* <div>
    
<h2 className="itineraryInclusion">Common links/details for all BHUTAN Itineraries:</h2>

<h3 className="itineraryInclusion">Accommodation Details</h3>

<div className="tableWrap">
<table className="priceTable">
<thead>
<tr>
<th>DESTINATIONS</th>
<th>ECONOMY (MAP)</th>
<th>SUPERIOR (MAP)</th>
<th>LUXURY (MAP)</th>
<th>CLASSY (MAP)</th>
<th>SPLENDID (MAP)</th>
<th>PREMIUM (MAP)</th>
<th>ELITE (MAP)</th>
</tr>
</thead>

<tbody>
<tr>
<td>PHUENTSHOLING</td>
<td>Gadhen Hotel (Deluxe) / Evergreen9 / Similar</td>
<td>Hotel Palm / Lhaki / Similar</td>
<td>Tara Phendeyling / Meto Pema / Similar</td>
<td>Bhutan Ga Me Ga (Standard) / Lotus Villa / Similar</td>
<td>Tashi Namgay Grand / Similar</td>
<td>Druk Hotel/ Similar</td>
<td>Druk Hotel / Similar</td>
</tr>

<tr>
<td>THIMPHU</td>
<td>Bhutan Kubera / Starlight / Similar</td>
<td>Migmar / Forest Boutique / Similar</td>
<td>Asura / Pelyang Boutique / Similar</td>
<td>Ariya / Tashi-Yid Wong / Similar</td>
<td>Termalinca Resorts And Spa / Himalayan Keys Forest Resort / Similar</td>
<td>Le Meridien (Classic) / Yarkay IHCL Seleqtions / Similar</td>
<td>Le Meridien (Deluxe) /Yarkay IHCL Seleqtions (Deluxe) / Similar</td>
</tr>

<tr>
<td>WANGDUE / PUNAKHA</td>
<td>White Dragon / Khuru Khuru / Similar</td>
<td>Pema Karpo / Classic Wood / Punakha Boutique / Similar</td>
<td>Zhingkham Resort / River Valley (Deluxe) / Similar</td>
<td>Rkpo Green Resort / Similar</td>
<td>Rkpo Green Resort / Similar</td>
<td>Dhensa Boutique Resort / Similar</td>
<td>Dhensa Boutique Resort / Similar</td>
</tr>

<tr>
<td>PARO</td>
<td>Gonju Boutique / Center Point / Similar</td>
<td>Gawaling / River Front / Similar</td>
<td>Paro Grand Resort (Deluxe) / Olathang (Deluxe Cottage) / Similar</td>
<td>Tiger Nest Camp / Tashi Namgay Resort (Deluxe) / Similar</td>
<td>Kaachi Grand (Sky Deck) / Jagathang / Similar</td>
<td>Le Meridian River Front (Classic) / Similar</td>
<td>Le Meridian - River Front (Deluxe) / Similar</td>
</tr>

<tr>
<td>BHUMTHANG</td>
<td>Hotel Ugyen Ling / Similar</td>
<td>Hotel Ugyen Ling / Similar</td>
<td>Yugharling Resort (Std.Dlx) / Similar</td>
<td>Yugharling Resort (Std.Dlx) / Similar</td>
<td>Bhutan Mountain Resort / Similar</td>
<td>Bhutan Mountain Resort / Similar</td>
<td>Bhutan Mountain Resort / Similar</td>
</tr>
</tbody>
</table>
</div>
</div> */}

                      {/* <div>
            <h3 className="itineraryInclusion">Hotel Category Details:</h3>
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
            <li style={{ marginLeft: '6px' }}><strong>Economy Packages :</strong> Decent Hotel with Breakfast & Dinner with all Modern Amenities.</li>
            <li style={{ marginLeft: '6px' }}> <strong> Superior Packages :</strong> 3* Hotel with Breakfast & Dinner.</li>
            <li style={{ marginLeft: '6px' }}> <strong>Luxury Packages :</strong> 3* Deluxe Hotel with Breakfast & Dinner</li>
            <li style={{ marginLeft: '6px' }}><strong>Classy Packages :</strong> 4* Equivalent Services with Breakfast and Dinner.</li>
            <li style={{ marginLeft: '6px' }}><strong>Splendid Packages :</strong> 4* Hotel with Breakfast & Dinner.</li>
            <li style={{ marginLeft: '6px' }}><strong>Premium Packages :</strong> 5* or 4* Hotel with Breakfast & Dinner.</li>
            <li style={{ marginLeft: '6px' }}><strong>Elite Packages :</strong> 5* Deluxe Hotels & other Best available hotels (In this category)</li>
            </ul>
            </div> */}


          <div id="term-condition">
            <h2 className="itineraryHotelDetailHead">Our Policy</h2>
            <div>
              <ul
                className="itineraryInclusionUnderss"
                style={{ listStyleType: "circle" }}
              >
                {data.tour_policy
                  .filter((item) => item && item.trim() !== "")
                  .map((item) => (
                    <li>{item}</li>
                  ))}
              </ul>
            </div>
          </div>
          <div>
            <h2 className="itineraryHotelDetailHead">Cancellation Policy</h2>
            <div>
              <ul
                className="itineraryInclusionUnderss"
                style={{ listStyleType: "circle" }}
              >
                {data.cancelation_policy
                  .filter((item) => item && item.trim() !== "")
                  .map((item) => (
                    <li>{item}</li>
                  ))}
              </ul>
            </div>
          </div>
          <div>
            <h2 className="itineraryHotelDetailHead">Payment Policy</h2>
            <div>
              <ul
                className="itineraryInclusionUnderss"
                style={{ listStyleType: "circle" }}
              >
                {data.payment_policy
                  .filter((item) => item && item.trim() !== "")
                  .map((item) => (
                    <li>{item}</li>
                  ))}
              </ul>
            </div>
          </div>
{/* <div>
<h3 className="itineraryInclusion">Bhutan Package Pricing (Per Person)</h3>

<div className="tableWrap">
<table className="priceTable">
  <thead>
    <tr>
      <th>PAX</th>
      <th>Economy</th>
      <th>Superior</th>
      <th>Luxury</th>
      <th>Classy</th>
      <th>Splendid</th>
      <th>Premium</th>
      <th>Elite</th>
    </tr>
  </thead>

  <tbody>
    <tr><td>02 Pax</td><td>33200</td><td>35000</td><td>39800</td><td>48900</td><td>56100</td><td>79000</td><td>84300</td></tr>
    <tr><td>04 Pax</td><td>26500</td><td>28200</td><td>33000</td><td>42100</td><td>49300</td><td>72400</td><td>77800</td></tr>
    <tr><td>06 Pax</td><td>22700</td><td>24500</td><td>29200</td><td>38300</td><td>45500</td><td>68800</td><td>74100</td></tr>
    <tr><td>08 Pax</td><td>21400</td><td>23100</td><td>27900</td><td>37000</td><td>44200</td><td>67500</td><td>72800</td></tr>
  </tbody>
</table>
</div>

<p className="note">
Rates & services are subject to Bhutan Government regulations.
</p>
</div> */}

{/* <div  id="important-info">
<h3 style={{marginTop:'15px'}} >Important Information</h3>

<h4 className="itineraryInclusion">Accommodation Standards & Upgrades</h4>
<ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
<li style={{ marginLeft: '6px' }}>Property Selection: We strive to maintain consistent star ratings across your itinerary. However, in certain remote or niche destinations, where specific categories may not be available, we handpick the best available local alternative to ensure your comfort and safety.</li>
<li style={{ marginLeft: '6px' }}>Ultra-Luxury Portfolio: For guests seeking an elevated experience, we offer exclusive rates and bespoke arrangements with premier luxury collections, including Como Uma, The Postcard, Pemako, Amankora, and Six Senses. These are available upon request and customized on a case-to-case basis.</li>
</ul>

<h4 className="itineraryInclusion">Culinary Experience</h4>
<ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
<li style={{ marginLeft: '6px' }}>Menu Offerings: Our partner hotels serve a basic variety of freshly prepared Vegetarian and Non-Vegetarian options. The focus is on providing wholesome, local, and standard flavors.</li>
<li style={{ marginLeft: '6px' }}>Dietary Notes: While we ensure high-quality basic Indian cuisine, please note that specialized regional or niche Indian ethnic dishes may be limited by local ingredient availability. We recommend sharing any specific dietary requirements with us in advance to help our partners prepare accordingly.</li>
</ul>


<h3 className="itineraryInclusion">Entry Permit for Bhutan (Indian Nationals)</h3>
<p className="itineraryInclusionUnder">Indian nationals do not require a visa to travel to Bhutan. However, a valid Entry Permit is mandatory for travel beyond the border checkpoints.</p>

<h4 className="itineraryInclusion">Required Documents</h4>
<ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
<li style={{ marginLeft: '6px' }}>Valid Indian Passport (with minimum 6 months validity from date of travel), OR</li>
<li style={{ marginLeft: '6px' }}>Original Indian Voter ID Card (physical card only)</li>
<li style={{ marginLeft: '6px' }}>Valid Travel Insurance covering the duration of stay in Bhutan is mandatory.</li>
<li style={{ marginLeft: '6px' }}>Passport-size photographs may be required as per prevailing regulations.</li>
</ul>

<p style={{ fontSize:'14px'}}> <strong>Please note:</strong> Aadhaar Card, PAN Card, Driving License, or digital copies are not accepted as valid travel documents for entry into Bhutan.</p>

<h4  className="itineraryInclusion">Advance Online Permit Processing</h4>
<ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
<li style={{ marginLeft: '6px' }}>Clear, colored scanned copy of Passport (if traveling on Passport)</li>
<li style={{ marginLeft: '6px' }}>Travel Insurance copy</li>
<li style={{ marginLeft: '6px' }}>Recent passport-size photograph</li>
<li style={{ marginLeft: '6px' }}>Any additional documents required under current Bhutan regulations</li>
</ul>

<p style={{marginBottom:'10px', fontSize:'14px'}}>All documents must reach us at least 10 working days prior to departure.</p>

<p style={{marginBottom:'10px', fontSize:'14px'}}>Permit approval remains subject to the discretion of Bhutan immigration authorities.</p>



<h3 className="itineraryInclusion">Bhutan-Travel-advisory-indians</h3>

<h2 className="itineraryInclusion">Bhutan Travel Advisory for Indian Nationals (2026)</h2>

<ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
<li style={{ marginLeft: '6px' }}>SDF for Indians: A mandatory fee of INR 1,200 per person per night is appli cable.</li >
<li style={{ marginLeft: '6px' }}>Travel Insurance is mandatory.</li >
<li style={{ marginLeft: '6px' }}>Local SIM available on arrival.</li >
<li style={{ marginLeft: '6px' }}>Layered clothing recommended.</li >
<li style={{ marginLeft: '6px' }}>Photography restricted inside monasteries.</li >
<li style={{ marginLeft: '6px' }}>Smoking prohibited in public places.</li>
</ul>


<h2 className="itineraryInclusion">The Ultimate Bhutan Travel Checklist</h2>

<ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
<li style={{ marginLeft: '6px' }}>Original Passport or Voter ID</li>
<li style={{ marginLeft: '6px' }}>Passport Size Photos</li>
<li style={{ marginLeft: '6px' }}>Travel Insurance copy</li>
<li style={{ marginLeft: '6px' }}>Cash small denominations</li>
<li style={{ marginLeft: '6px' }}>Layered clothing</li>
<li style={{ marginLeft: '6px' }}>Hiking shoes</li>
<li style={{ marginLeft: '6px' }}>Power bank</li>
<li style={{ marginLeft: '6px' }}>Offline Google Maps</li>
</ul>

<div className="">
<h4 className="itineraryInclusion"> Mobile Connectivity & Internet</h4>
<ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
<li  style={{ marginLeft: '6px' }}>Roaming: Indian mobile networks may not function reliably. We recommend checking with your provider for specific international roaming packs.</li>
<li  style={{ marginLeft: '6px' }}>Local SIMs: Local SIM cards can be arranged upon arrival at the border or airport (subject to providing a copy of your permit and ID).</li>
<li  style={{ marginLeft: '6px' }}>Wi-Fi: Available in most hotels, though speeds may vary in remote or higher-altitude valleys.</li>
</ul>

<h4  className="itineraryInclusion">Weather, Clothing & Altitude</h4>
<p style={{marginBottom:'10px', fontSize:'14px'}}>Bhutan’s climate varies significantly by altitude and season.</p>
<ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
<li  style={{ marginLeft: '6px' }}>Spring (March–May): Pleasant weather with blooming rhododendrons.</li>
<li  style={{ marginLeft: '6px' }}>Autumn (September–November): Clear skies and peak mountain visibility.</li>
<li >Winter: Higher valleys can be very cold; layered clothing is essential.</li>
<li  style={{ marginLeft: '6px' }}>Footwear: Comfortable walking shoes are a must, particularly for the Tiger’s Nest (Paro Taktsang) hike.</li>
<li  style={{ marginLeft: '6px' }}>Altitude Health: Thimphu and Paro are above 2,000m. Stay hydrated, avoid overexertion on Day 1, and consult a doctor if you have respiratory or cardiac conditions.</li>
<li  style={{ marginLeft: '6px' }}>Pony services for Tiger's Nest are available up to the midpoint for those requiring assistance.</li>
</ul>

<h4  className="itineraryInclusion">Road Travel & Driving Conditions</h4>
<ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">

<li  style={{ marginLeft: '6px' }}>Mountainous Terrain: Roads are scenic but winding. Driving speeds are moderate for safety.</li>
<li  style={{ marginLeft: '6px' }}>Buffer Time: Landslides or roadblocks can occur during the monsoon. We advise a relaxed itinerary with buffer time for travel between districts.</li>
<li  style={{ marginLeft: '6px' }}>Vehicles: We recommend using locally authorized Bhutanese transport for better navigation and compliance with local permits.</li>
</ul>

<h4  className="itineraryInclusion">Cultural Etiquette & Photography</h4>
<ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
<li  style={{ marginLeft: '6px' }}>Attire: Modest dress is mandatory for Dzongs (fortresses) and monasteries. Shoulders and knees must be covered.</li>
<li  style={{ marginLeft: '6px' }}>Sacred Spaces: Photography is strictly prohibited inside religious premises. Always seek permission before photographing local people.</li>
<li  style={{ marginLeft: '6px' }}>Behavior: Avoid loud behavior or littering in sacred spaces. Respect the "High-Value, Low-Impact" tourism philosophy.</li>
</ul>

<h4  className="itineraryInclusion">Responsible & Sustainable Travel</h4>
<ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
<li  style={{ marginLeft: '6px' }}>Tobacco: Smoking in public places is strictly prohibited and carries heavy fines.</li>
<li  style={{ marginLeft: '6px' }}>Local Support: We encourage travelers to support local handicrafts and artisans, ensuring that tourism benefits the Bhutanese community directly.</li>
</ul>

<h3 className="itineraryInclusion">The Ultimate Bhutan Travel Checklist</h3>
<p style={{marginBottom:'10px', fontSize:'14px'}} >Prepared by Plenary Holidays – Your MICE & Leisure Experts</p>
<ul style={{ listStyleType: 'circle', paddingLeft: '20px' }} className="itineraryInclusionUnder">
<li  style={{ marginLeft: '6px' }}> Original Passport or Voter ID: (Aadhar is not valid).</li>
<li  style={{ marginLeft: '6px' }}>Passport Size Photos: Carry at least 4 recent photographs.</li>
<li  style={{ marginLeft: '6px' }}>Birth Certificate: Original English copy for minors (under 18).</li>
<li  style={{ marginLeft: '6px' }}>Travel Insurance: Copy of your comprehensive policy (mandatory).</li>
<li  style={{ marginLeft: '6px' }}>Permit Copies: Multiple photocopies of your entry permit once issued.</li>
<li  style={{ marginLeft: '6px' }}>Cash (Small Denominations): INR 100 and 200 notes are most reliable.</li>
<li  style={{ marginLeft: '6px' }}>Cards: International Debit/Credit cards (ensure 'International Usage' is enabled).</li>
<li  style={{ marginLeft: '6px' }}>UPI: BHIM/PhonePe work in major towns but carry cash for remote areas.</li>
<li  style={{ marginLeft: '6px' }}>The 3-Layer Rule: Thermals, a light fleece/sweater, and a windproof/waterproof jacket.</li>
<li  style={{ marginLeft: '6px' }}>Monastery Attire: Collared shirts/tops and full-length trousers (mandatory for Dzongs).</li>
<li  style={{ marginLeft: '6px' }}>Hiking Gear: Broken-in walking shoes/hiking boots for Tiger’s Nest.</li>
<li  style={{ marginLeft: '6px' }}>Accessories: Sunglasses, a wide-brimmed hat, and a reusable water bottle.</li>
<li style={{ marginLeft: '6px' }}>Altitude Meds: Consult your doctor for Diamox or similar (Thimphu/Paro are at high altitudes).</li>
<li style={{ marginLeft: '6px' }}>Motion Sickness: Essential if you are prone to nausea on winding mountain roads.</li>
<li style={{ marginLeft: '6px' }}>Sun Protection: High-SPF sunscreen and lip balm (the mountain sun is strong).</li>
<li style={{ marginLeft: '6px' }}>Personal Meds: A 15-day supply of any regular medication.</li>
<li style={{ marginLeft: '6px' }}>Universal Adapter: Most hotels use Indian/European style sockets, but a multi-pin is safer.</li>
<li style={{ marginLeft: '6px' }}>Power Bank: Essential for long driving days between valleys.</li>
<li style={{ marginLeft: '6px' }}>Offline Maps: Download Google Maps for Bhutan for offline use.</li>
</ul>

</div>

</div> */}



        </div>
      </div>
    </>
  );
};

export default ItinearySection;
